export default ['daniel.garrido@foodforjoe.es'];
